import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetExamTypeDto } from '../../../common/spdCore/autogenerated/spdApiClient';

import { Selector, Option } from './Selector';

export interface ExamTypeSelectorProps {
  readOnly?: boolean;
  value?: string;
  placeholder?: string;
  className?: string;
  onChange?: (option: Option) => void;
}

export default (props: ExamTypeSelectorProps) => {
  const spd = useSpdCore();
  const [examTypes, setExamTypes] = useState<GetExamTypeDto[]>([]);
  const [displayName, setDisplayName] = useState<string>();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (props.value) {
      spd.examTypes
        .get(props.value || '')
        .then(et => {
          setDisplayName(et.name || '');
        })
        .catch(error =>
          console.log(`Wystąpił problem z pobraniem typów badań. ${error}`),
        );
    }
  }, [props.value, spd.examTypes]);

  useEffect(() => {
    let mounted = true;
    spd.examTypes
      .getAll()
      .then(et => {
        if (mounted) {
          setExamTypes(et);
          setReady(true);
        }
      })
      .catch(error =>
        console.log(`Wystąpił problem z pobraniem typów badań. ${error}`),
      );

    return () => {
      mounted = false;
    };
  }, [spd.examTypes]);

  const provider = async (text: string) => {
    const values = examTypes.filter(v => {
      const name = v.name || '';
      return name.toLocaleLowerCase().includes(text.toLocaleLowerCase());
    });

    return values.map(v => {
      return {
        label: v.name || '',
        value: v.id,
      };
    });
  };

  return ready ? (
    <Selector
      uniqueKey={'examTypes-' + JSON.stringify(examTypes)}
      className={props.className}
      readOnly={props.readOnly}
      creatable={false}
      placeholder={props.placeholder || 'Wskaż...'}
      provider={provider}
      value={displayName}
      onChange={props.onChange}
    />
  ) : (
    <Skeleton />
  );
};
